export enum PREFERENCE {
  IN = 'in',
  OUT = 'out'
}

export enum ProductTypeName {
  BUNDLE_PRODUCT = "BundleProduct",
  GROUPED_PRODUCT = "GroupedProduct"
}